import { usePdfDetails } from "@library/components/pdf";
const useGetSearchParams = () => {
  const { acceptPayload } = usePdfDetails();
  const url = new URL(window.location.href);
  const params = url.searchParams;

  let name, email, role, timestamp, sealPDF;

  if (acceptPayload) {
    name = acceptPayload.name;
    email = acceptPayload.email;
    role = acceptPayload.role;
    timestamp = acceptPayload.timestamp;
    sealPDF = true;
  } else {
    name = params.get("name");
    email = params.get("email");
    role = params.get("role");
    timestamp = params.get("timestamp");
    sealPDF = params.get("sealPDF");
  }

  if (role === "undefined") role = "";

  return { name, email, role, timestamp, sealPDF };
};

export default useGetSearchParams;
